import React from 'react';
/**
 * Header row stateless component.
 * contains static markup for tables header.
 * @constructor
 */
const HeaderRow = () => (
    <tr className="tn-pressChallenge__headerRow">
        <th className="ui-table__cell" />
        <th className="ui-table__cell hideFromNarrow hide_month" colSpan="2">
            Records for all races this year
        </th>
        <th className="ui-table__cell hideToNarrow hideToMedium_month" colSpan="3">
            Records for all races this year
        </th>
        <th className="ui-table__cell hide showToMedium_month" colSpan="3">
            Records for all races this month
        </th>
        <th className="ui-table__cell hideFromMedium" colSpan="1">
            Naps
        </th>
        <th className="ui-table__cell hideToMedium" colSpan="2">
            Naps
        </th>
        <th className="ui-table__cell hideToMedium" colSpan="2">
            Monthly record
        </th>
    </tr>
);

export default HeaderRow;



// WEBPACK FOOTER //
// ./src/js/pressChallenge/HeaderRow.js